module.exports = __webpack_public_path__ + "assets/cdbl-logo--header.781e9209.svg";